import React, { useState } from 'react';
typeof window !== 'undefined' && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = '2.10.0');
import { Tablist, TabPanel } from './components';
import * as Styles from './styles';
/**
 * Componente Tabs do Design System OLX.
 * A estrutura de Tabs possui componentes auxiliares necessários: Tab e TabPanel
 */
export const Tabs = _ref => {
  let {
    isPersistent,
    children,
    onChange
  } = _ref;
  var _a;
  const tabs = React.Children.toArray(children);
  const initialSelectedTabId = ((_a = tabs.find(tab => tab.props.selected)) === null || _a === void 0 ? void 0 : _a.props.id) || tabs[0].props.id;
  const [selectedTabId, setSelectedTabId] = useState(initialSelectedTabId);
  const handleSelectTab = selectedTabId => {
    setSelectedTabId(selectedTabId);
    onChange === null || onChange === void 0 ? void 0 : onChange(selectedTabId);
  };
  return React.createElement(Styles.Tabs, {
    "data-ds-component": "DS-Tabs",
    role: "tablist"
  }, React.createElement(Tablist, {
    selectedTabId: selectedTabId,
    onSelectTab: handleSelectTab
  }, React.Children.map(children, tab => {
    if (!tab.props) return null;
    const selected = tab.props.id === selectedTabId;
    return React.cloneElement(tab, {
      selected,
      onSelectTab: handleSelectTab
    });
  })), React.createElement(React.Fragment, null, React.Children.map(children, tab => {
    if (!tab.props) return null;
    const {
      id
    } = tab.props;
    const selected = id === selectedTabId;
    const tabPanelProps = {
      id: id,
      selected: selected
    };
    if (selected && !isPersistent) {
      return React.createElement(TabPanel, Object.assign({}, tabPanelProps), tab.props.children);
    }
    if (isPersistent) {
      return React.createElement(TabPanel, Object.assign({}, tabPanelProps), tab.props.children);
    }
  })));
};
Tabs.displayName = 'Tabs';